import { createFileRoute } from '@tanstack/react-router'

import { REPORT_TYPES } from '@repo/constants'
import { ReportsListPage } from '../-components/ReportsListPage'

export const Route = createFileRoute('/_auth/_modules/_app/reports/misc/')({
  component: Reports,
})

function Reports() {
  return <ReportsListPage reportType={REPORT_TYPES.MISC} route={Route} />
}
